<template>
  <div class="container_box details_box_styles">
    <div class="filter_box" v-for="item in payList">
      <div class="flex align-items-center justify-content-between">
        <div class="flex align-items-center">
          <img :src="item.logoImg" width="130" :height="item.payType === 1 ? 47 : 43" alt=""/>
          <span v-if="item.payType === 1 && !item.bindingTalg" class="mr2 ml2">{{ $t('key1006807') }}</span>
          <div class="ml20 flex flex-direction textStyle">
            <div v-if="item.bindingTalg">
              <p>{{ item.accountName + item.payAccountNumber }}</p>
              <p>{{ item.accountHolder + item.name }}</p>
            </div>
            <span v-else>{{ item.bindingText }}</span>
          </div>
        </div>
        <Button
          type="primary"
          v-if="getPermission('ymsPayAccount_bindAccount') || getPermission('ymsPayAccount_update')"
          @click="changeAccount(item)">
          {{ item.bindingTitle }}
        </Button>
      </div>
    </div>
    <!--变更日志-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1006808') }}</h2>
        </template>
        <div class="table_box">
          <Table
            highlight-row
            border
            max-height="500"
            :loading="tableLoading"
            :columns="tableColumns"
            :data="tableData">
          </Table>
          <Page
            :transfer="true"
            v-if="!tableLoading"
            :total="total"
            @on-change="changePage"
            show-total
            :page-size="pageParams.pageSize"
            show-elevator
            :current="pageParams.pageNum"
            show-sizer
            @on-page-size-change="changePageSize"
            placement="top"
            :page-size-opts="pageArray">
          </Page>
        </div>
      </Card>
    </div>
    <!--更换、绑定收款账户弹窗-->
    <setCollectionAccountModal ref="setCollectionAccount" @updateData="initFun()"></setCollectionAccountModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import setCollectionAccountModal from "@/views/supplier/components/accountManage/setCollectionAccountModal.vue";
import {getAllUsersInfo, getDataSetBatchList, getEnumName, getUserNameByUserId} from "@/utils/common";

export default {
  name: "collectionAccount",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        ymsPayAccountId: null,
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000289'),
          key: 'operationType',
          width: 120,
          align: 'center',
          render(h, params) {
            let text = '';
            let operationType = params.row.operationType;
            let jsonobj = params.row.originalRecord || params.row.changeRecord;
            let obj = JSON.parse(jsonobj);
            if (obj.payType === 1) {
              operationType === 1 ? text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006798') : operationType === 2 ? text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006799') : '';
            } else {
              operationType === 1 ? text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006797') : operationType === 2 ? text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006800') : '';
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002863'),
          key: 'originalRecord ',
          align: 'center',
          minWidth: 280,
          render(h, params) {
            let content = '-';
            let obj = {};
            let originalRecord = params.row.originalRecord;
            let name = '';
            if (originalRecord) {
              obj = JSON.parse(originalRecord);
              let payName = getEnumName(v.enumData, 'YmsPayAccountPayTypeSupplierEnum', obj.payType);
              if (obj.payType === 1) {
                name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002705');
              } else {
                name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002707');
              }
              content = [
                h('div', {style: 'textAlign: left'}, [
                  h('p', {class: 'mt5 mb3'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002702') + payName),
                  h('p', {class: 'mt3 mb3'}, name + obj.payAccountNumber),
                  h('p', {class: 'mt3 mb3'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002703') + obj.name)
                ])
              ];
            }
            return h('div', {class: 'flex align-items-center pl20 pr20'}, content);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002864'),
          key: 'changeRecord',
          align: 'center',
          minWidth: 280,
          render(h, params) {
            let content = '-';
            let obj = {};
            let name = '';
            let payName = '';
            let changeRecord = params.row.changeRecord;
            if (changeRecord) {
              obj = JSON.parse(changeRecord);
              if (obj.payType === 1) {
                name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002705');
                payName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002690');
              } else {
                name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002707');
                payName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002692');
              }
              content = [
                h('div', {style: 'textAlign: left'}, [
                  h('p', {class: 'mt5 mb3'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002702') + payName),
                  h('p', {class: 'mt3 mb3'}, name + obj.payAccountNumber),
                  h('p', {class: 'mt3 mb3'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002703') + obj.name)
                ])
              ];
            }
            return h('div', {class: 'flex align-items-center pl20 pr20'}, content);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006801'),
          key: 'updatedTime',
          align: 'center',
          minWidth: 180,
          render(h, params) {
            return h('div', v.$uDate.dealTime(params.row.updatedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003445'),
          key: 'auditStatus',
          align: 'center',
          minWidth: 180,
          render(h, params) {
            let changeRecord = params.row.changeRecord;
            if (changeRecord) {
              let obj = JSON.parse(changeRecord);
              let auditStatus = obj.updateSupplierPayAccountAuditStatus;
              let auditRemark = obj.updateSupplierPayAccountAuditRemark || '';
              let statusMap = {
                0: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002713'),
                1: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002944'),
                2: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000986')
              };
              let text = statusMap[auditStatus] || '-';
              if (auditStatus === 0) {
                return h('div', {class: 'flex align-items-center', style: {justifyContent: 'center'}}, [
                  h('span', {
                    style: {
                      color: '#e60b0b'
                    }
                  }, text),
                  h('Tooltip', {
                    props: {
                      transfer: true,
                      maxWidth: 250,
                      placement: 'top',
                      content: auditRemark
                    },
                    style: {
                      marginLeft: '5px'
                    }
                  }, [
                    h('Icon', {
                      props: {
                        type: 'md-help-circle',
                        size: 17
                      },
                      style: {
                        cursor: 'pointer',
                        color: '#e60b0b'
                      }
                    })
                  ])
                ]);
              }
              return h('span', text);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003806'),
          key: 'updateSupplierPayAccountAuditTime',
          align: 'center',
          minWidth: 180,
          render(h, params) {
            let changeRecord = params.row.changeRecord;
            if (changeRecord) {
              let obj = JSON.parse(changeRecord);
              return h('div', v.$uDate.dealTime(obj.updateSupplierPayAccountAuditTime, 'fulltime'));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'updatedBy',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.updatedBy, v.userInfoList, '/accountManage/collectionAccount'));
          }
        }
      ],
      tableData: [],
      originalPayList: [
        {
          accountName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002705'),
          accountHolder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002703'),
          payType: 1,
          payAccountNumber: '', // 银行卡号
          name: '', // 开户人姓名
          logoImg: require('@/assets/images/pay/bankCard.png'),
          bindingTalg: false, // 是否绑定
          bindingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006802'),
          bindingTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006803'),
        },
        {
          accountName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002707'),
          accountHolder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002703'),
          payType: 2,
          payAccountNumber: '', // 支付宝账户
          name: '', // 开户人姓名
          logoImg: require('@/assets/images/pay/alipay.png'),
          bindingTalg: false, // 是否绑定, true 已绑定  false 未绑定
          bindingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006804'),
          bindingTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006795'),
        }
      ],
      payList: [],
      bindingTalg: false,
      userInfoList: {},
      enumData: []
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        this.enumData = await getDataSetBatchList(['YmsPayAccountPayTypeSupplierEnum']);
        await getAllUsersInfo().then(data => {
          this.userInfoList = data;
        });
        await this.getAlipayAccount();
      })();
      this.pageParamsStatus = true;
    },
    // 获取绑定支付的数据
    getAlipayAccount() {
      let v = this;
      let list = [];
      v.payList = [];
      v.bindingTalg = false;
      if (v.getPermission('ymsPayAccount_query')) {
        v.tableLoading = true;
        v.axios.get(api.get_ymsPayAccount).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              data.map((item) => {
                v.originalPayList.map((ele) => {
                  if (item.payType === ele.payType) {
                    v.bindingTalg = true;
                    v.pageParams.ymsPayAccountId = item.ymsPayAccountId;
                    ele.bindingTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006805');
                    ele.bindingTalg = true;
                    let obj = Object.assign({}, ele, item);
                    list.push(obj);
                  }
                });
              });
              if (list.length > 0) {
                v.payList = list;
                v.$forceUpdate();
              }
            } else {
              v.payList = JSON.parse(JSON.stringify(v.originalPayList));
            }
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          }
        }).catch((err) => {
          v.tableLoading = false;
        });
      } else {
        v.gotoError();
      }
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableLoading = true;
      v.tableData = [];
      v.axios.post(api.post_ymsPayAccountLog_query, v.pageParams).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas;
          v.tableData = data.list || [];
          v.total = data.total;
        }
      });
    },
    // 变更账户
    changeAccount(item) {
      let status = item.updateSupplierPayAccountAuditStatus;
      if (status !== 1) {
        this.$refs['setCollectionAccount'].initSetCollectionAccountData(item)
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006806'));
        return false;
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    setCollectionAccountModal
  }
};
</script>

<style lang="less" scoped>
.filter_box {
  padding: 20px 15px;

  .textStyle {
    font-size: 14px;
    color: #333;
  }
}

</style>
